import React, { useState, useEffect } from 'react';

//bs
import { Col, Container, Row } from 'reactstrap';

//api
import * as mainApi from '../api/mainApi';

//components
import CatalogoItem from './catalog/CatalogoItem';

//helpers
import { showGlobalAlert } from 'context/AlertContext';
import CatalogDetail from './catalog/CatalogDetail';

//GA
import ReactGA from "react-ga4";

const CatalogPage = () => {
	const [categories, setCategories] = useState([]);
	const [activeCatId, setActiveCatId] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const handleGetProducts = async () => {
		setIsLoading(true);
		const data = await mainApi.getProducts();
		if (data && data.succeded) {
			const cats = data.data || [];
			setCategories(cats);
			if (cats.length > 0) setActiveCatId(cats[0].id);
		} else {
			showGlobalAlert(
				'¡Ups!',
				'Ha ocurrido un error. Inténtalo de nuevo en unos minutos.',
			);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		handleGetProducts();
	}, []);

	const activeProducts =
		categories.find((c) => c.id === activeCatId)?.products || [];

	const [viewProduct, setViewProduct] = useState(null);
	const handleViewProduct = (product) => {
		ReactGA.send({ hitType: 'event', eventCategory: 'Catalog', eventAction: 'View Product', eventLabel: product.name });
		setViewProduct(product);
	};

	return (
		<div className="catalog-page">
			<Container>
				<Row>
					<Col lg="12">
						<h1 className="title">DESCUBRE NUESTRO CATÁLOGO</h1>
					</Col>
				</Row>

				{isLoading ? (
					<p>Cargando productos...</p>
				) : (
					<>
						<Row>
							<Col lg="12">
								<div className="filters">
									{categories.map((cat) => (
										<button
											key={cat.id}
											className={activeCatId === cat.id ? 'active' : ''}
											onClick={() => { setActiveCatId(cat.id); setViewProduct(null); }}
										>
											{cat.name}
										</button>
									))}
								</div>
							</Col>
						</Row>

						<Row>
							<Col lg="12">
								<div className="breadcrumb">
									<span
										className="breadcrumb__item"
										onClick={() => {
											setViewProduct(null);
											setActiveCatId(categories[0]?.id ?? null);
										}}
									>
										Catálogo
									</span>
									{activeCatId &&
										(() => {
											const activeCat = categories.find(
												(c) => c.id === activeCatId,
											);
											return activeCat ? (
												<>
													<span className="breadcrumb__sep">/</span>
													<span
														className="breadcrumb__item"
														onClick={() => setViewProduct(null)}
													>
														{activeCat.name}
													</span>
												</>
											) : null;
										})()}
									{viewProduct && (
										<>
											<span className="breadcrumb__sep">/</span>
											<span className="breadcrumb__item breadcrumb__item--active">
												{viewProduct.name}
											</span>
										</>
									)}
								</div>
							</Col>
						</Row>

						{viewProduct ? (
							<Row>
								<Col lg="12">
									<CatalogDetail
										product={viewProduct}
										onBack={() => setViewProduct(null)}
									/>
								</Col>
							</Row>
						) : (
							<Row>
								<Col lg="12">
									{activeProducts.length > 0 ? (
										<div className="grid" key={activeCatId}>
											{activeProducts.map((product) => (
												<CatalogoItem
													key={product.id}
													product={product}
													onView={handleViewProduct}
												/>
											))}
										</div>
									) : (
										<p className="no-products">
											No hay productos en esta categoría.
										</p>
									)}
								</Col>
							</Row>
						)}
					</>
				)}
			</Container>
		</div>
	);
};

export default CatalogPage;
